import AssessmentAttemptPage from "./assessmentAttemptPage"
export default AssessmentAttemptPage;
